export function getNameValidations(intl, messages) {
  return {
    validations: {
      isEmail: true,
      maxLength: 40,
    },
    validationErrors: {
      isEmail: intl.formatMessage({
        ...messages.field_must_be_an_email,
      }),
      maxLength: intl.formatMessage({
        ...messages.field_max_length_40,
      }),
    },
  };
};


// WEBPACK FOOTER //
// ./src/core/validations.js